// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__K9w1I"};